/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

export const azure_issuer = "login.microsoftonline.com/0eee4667-af50-44fe-abd2-0490655d3721/v2.0";

export const env_configs = {
  "dev": {
    clientId: 'c243f1ac-943c-449a-9064-47ef1f4895de',
    redirectUri: 'https://dhfnavigator-dev.vareximaging.com/Home',
    scope: 'openid profile email',
  },
  "val": {
    clientId: '1d3e7870-c54f-49b2-a8b0-b1d9131dd7c1',
    redirectUri: 'https://dhfnavigator-qa.vareximaging.com/Home',
    scope: 'openid profile email',
  },
  "prod": {
    clientId: '76141c65-32ba-4e50-9905-5280c57588b3',
    redirectUri: 'https://dhfnavigator.vareximaging.com/Home',
    scope: 'openid profile email',
  }

}

const config = (process.env.REACT_APP_STAGE === 'prod') ? "prod"
: (process.env.REACT_APP_STAGE === 'val') ? "val"
: "dev";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
  auth: {
    clientId: env_configs[config].clientId,
    authority: "https://login.microsoftonline.com/0eee4667-af50-44fe-abd2-0490655d3721/",
    redirectUri: env_configs[config].redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};

